import {extensionMailSyncId} from 'yougile-model'
import {globals} from '@extensions/globals-base'
import {getFixedUrl} from './get-fixed-url'

export const getRightUrl = (src: string): string => {
  if (!src) {
    return src
  }

  if (src.startsWith('http://') || src.startsWith('https://')) {
    return src
  }

  const webPlatformUrl = getCorrectWebPlatformUrl()
  if (webPlatformUrl) {
    return getFixedUrl(`${webPlatformUrl}/${src}`)
  }

  return src
}

export const getExtensionMediaUrl = (
  extensionId: string,
  src: string
): string => {
  const prefix = `/extensions/${extensionId}`
  src = src.replace(/^\/\./, '')

  // Backward compatibility
  // Covers legacy previews[], where we've set
  // links like this: '/extension/<extname>/img.png'
  if (src.includes(prefix) || src.includes('/img/extensions/')) {
    return getRightUrl(src)
  }

  if (extensionId === extensionMailSyncId) {
    return `/img/extensions/mail-sync/media/${src}`
  }

  return getRightUrl([prefix, 'media', src].join('/'))
}

export const getExtensionPublicUrl = (
  extensionId: string,
  src: string
): string => {
  src = src.replace(/^\/\./, '')
  return getRightUrl(`/extensions/${extensionId}/${src}`)
}

const getCorrectWebPlatformUrl = () => {
  const webPlatformUrl = globals.webPlatformUrl
  if (!webPlatformUrl) {
    return ''
  }

  if (webPlatformUrl === 'https://yougile.example.com') {
    return 'http://localhost:8001'
  }

  return globals.webPlatformUrl
}
